import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2fae6390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date ", -1))
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Client "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = {
  class: "card",
  style: {"padding":"0px !important"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title mb-0" }, "Liste des produits à vendre")
], -1))
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = {
  class: "table",
  style: {"width":"100% !important"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { style: {"width":"100% !important"} }, [
  /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"300px !important"} }, "Produit"),
  /*#__PURE__*/_createElementVNode("th", null, "Qté"),
  /*#__PURE__*/_createElementVNode("th", null, "Prix"),
  /*#__PURE__*/_createElementVNode("th", null, "Montant"),
  /*#__PURE__*/_createElementVNode("th", null, " Stock ")
], -1))
const _hoisted_17 = { style: {"margin-bottom":"5px !important"} }
const _hoisted_18 = { class: "badge text-outline-danger fs-7" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "card-footer" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Epargne "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Mise "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Montant / 20 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1))
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-12" }
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "elementForm",
        onSubmit: _ctx.addElement,
        "validation-schema": _ctx.venteSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_Field, {
                    name: "dateVente",
                    type: "date",
                    value: _ctx.getCurrentDate(),
                    class: "form-control shadow-none fs-md-15 text-black"
                  }, null, 8, ["value"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateVente",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_Field, { name: "client" }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(_component_Multiselect, _mergeProps({
                        options: _ctx.clientOptions,
                        searchable: true,
                        "track-by": "label",
                        label: "label",
                        modelValue: field.value,
                        "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                      }, field, { placeholder: "Sélectionnez le client" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "client",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produitConds, (pc, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_17, [
                              _createVNode(_component_Field, {
                                name: 'pcv_'+index,
                                modelValue: pc.produitConditionnement,
                                "onUpdate:modelValue": ($event: any) => ((pc.produitConditionnement) = $event),
                                style: {"min-width":"50px !important"}
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_component_Multiselect, _mergeProps({
                                    modelValue: field.value,
                                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                    ref_for: true
                                  }, field, {
                                    options: _ctx.getFilteredOptions(index),
                                    searchable: true,
                                    placeholder: "Rechercher",
                                    noResultText: "Aucun enregistrement trouvé",
                                    noOptionsText: "Tapez au moins deux caractères"
                                  }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                                ]),
                                _: 2
                              }, 1032, ["name", "modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: 'pcv_'+index,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_Field, {
                                name: 'pcv_qteVendu'+index,
                                type: "text",
                                modelValue: pc.qteVendu,
                                "onUpdate:modelValue": ($event: any) => ((pc.qteVendu) = $event),
                                onInput: ($event: any) => (_ctx.validateQuantity(index)),
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "0"
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                              _createVNode(_component_ErrorMessage, {
                                name: 'pcv_qteVendu'+index,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_Field, {
                                name: 'pcv_prix'+index,
                                type: "number",
                                modelValue: pc.prix,
                                "onUpdate:modelValue": ($event: any) => ((pc.prix) = $event),
                                onInput: ($event: any) => (_ctx.validatePrice($event, index)),
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "0"
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                              _createVNode(_component_ErrorMessage, {
                                name: 'pcv_prix'+index,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_Field, {
                                name: 'pcv_montant'+index,
                                type: "text",
                                modelValue: pc.montant,
                                "onUpdate:modelValue": ($event: any) => ((pc.montant) = $event),
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "0"
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: 'pcv_montant'+index,
                                class: "text-danger"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(pc.qteStock), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-outline-danger",
                                onClick: ($event: any) => (_ctx.removeLigne(index))
                              }, " x ", 8, _hoisted_19)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addProduit && _ctx.addProduit(...args)))
                    }, " + produit ")
                  ])
                ])
              ]),
              _hoisted_21,
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_Field, {
                    name: "epargne",
                    type: "text",
                    modelValue: _ctx.montantEpargne,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.montantEpargne) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "0"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "epargne",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_Field, {
                    name: "mise",
                    type: "text",
                    modelValue: _ctx.montantMise,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.montantMise) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black",
                    readonly: "",
                    placeholder: "0"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "mise",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_Field, {
                    name: "mt20",
                    type: "text",
                    modelValue: _ctx.mt20,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mt20) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black",
                    readonly: "",
                    placeholder: "0"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "mt20",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", _hoisted_34, [
                    _createTextVNode(" Montant total "),
                    _hoisted_35,
                    _createTextVNode(" ( " + _toDisplayString(_ctx.total) + " ) ", 1)
                  ]),
                  _createVNode(_component_Field, {
                    name: "montant",
                    type: "text",
                    modelValue: _ctx.montantTotal,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.montantTotal) = $event)),
                    class: "form-control shadow-none fs-md-15 text-black",
                    readonly: "",
                    placeholder: "0"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "montant",
                    class: "text-danger"
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40))
                    : (_openBlock(), _createElementBlock("span", _hoisted_41, "Enregistrer"))
                ], 8, _hoisted_39),
                _createVNode(_component_router_link, {
                  to: "/ventes",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_42,
                    _hoisted_43,
                    _createTextVNode("Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}